import MainCard from "components/MainCard";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const ComponentStatusDiv = ({
    equipment, 
    equipmentComponents, 
    componentId, 
    equipmentPartsByComponentId, 
    hasControlData, 
    hasTimelineData, 
    isPannelLoaded=true, 
    target="default"
}) => {
    const { t } = useTranslation();
    const [isPannelView, setIsPannelView] = useState(false);
    const [pannelBgColor, setPannelBgColor] = useState('#000');

    const didInitRef = useRef(false);
    
    useEffect(()=>{
        if (didInitRef.current || !isPannelLoaded) return;

        const isNoData = !equipment?.latestEquipmentOp && (!hasControlData && !hasTimelineData);
// console.log(isNoData)
        if (isNoData) {
            // if (equipmentComponents?.length > 0) {
            //     equipmentPartsByComponentId(equipmentComponents[0].id); // 첫번째 구성부
            // }
            equipmentPartsByComponentId(-3);    // 사진/도면
            
            didInitRef.current = true;
            return;
        } else {
            if (hasControlData || hasTimelineData) {
                equipmentPartsByComponentId(-1);    // 운전/진단
            } else {
                if (equipmentComponents?.length > 0) {
                    equipmentPartsByComponentId(equipmentComponents[0].id); // 첫번째 구성부
                }
            }
            didInitRef.current = true;
        }
    }, [
        isPannelLoaded,
        equipment?.latestEquipmentOp,
        hasControlData, 
        hasTimelineData, 
        equipmentComponents
    ])

    useEffect(()=>{
        // if (equipment?.equipmentCtgr?.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr?.parent?.parent?.code === 'ES') {
        // if (didInitRef.current) return;
        if (equipment?.latestEquipmentOp || hasControlData || hasTimelineData) {
            setIsPannelView(true);
            if (equipment?.latestEquipmentOp?.controlPanelCode?.alertYn === 'Y') {
                if (componentId===-1)
                    setPannelBgColor('6px solid #ed1c24');
                else
                    setPannelBgColor('2px solid #ed1c24');
            } else {
                if (componentId===-1)
                    setPannelBgColor('6px solid #0061d0');
                else
                    setPannelBgColor('2px solid #0061d0');
            }
        // } else {
        //     setIsPannelView(false);
        //     if (equipmentComponents?.length > 0 && !componentId) {
        //         equipmentPartsByComponentId(equipmentComponents[0].id)
        //     }
        }
    },[isPannelView, componentId, equipmentPartsByComponentId, hasControlData, hasTimelineData])
    
    const hasPanelTab = isPannelView;
    const hasComponentTab = equipmentComponents && equipmentComponents.length > 0;
    const hasAnyTab = hasPanelTab || hasComponentTab;

    if (!hasAnyTab) return null;

    return (
        <MainCard content={false} className="mobile_top">
            <div style={{padding:"5px"}} className="pannel_tab">
                {isPannelView && 
                <p className="statustab1" style={{borderBottom:`${pannelBgColor}`, color:`#fff`, fontWeight: componentId === -1 ? 700 : 400}} onClick={()=>{equipmentPartsByComponentId(-1)}}>{t('message.common.chip.panel')}</p>
                }
                <p className="statustab4" style={{borderBottom:`${componentId === -3 ? "6px solid #0061d0": "2px solid #0061d0"}`, color:`#fff`, fontWeight: componentId === -3 ? 700 : 400}} onClick={()=>{equipmentPartsByComponentId(-3)}}>{t('message.common.tabTitle.picture.data')}</p>
                {equipmentComponents && equipmentComponents.map(function(item, i) {
                    let componentName = item.name;
                    let bgColor = "6px solid #0061d0";
                    let defaultBgColor = "2px solid #0061d0";
                    if (item.countFaultCodesOfAlertY && item.countFaultCodesOfAlertY > 0) {
                        bgColor = "6px solid #ed1c24";
                        defaultBgColor = "2px solid #ed1c24";
                    } else if (item.countFaultCodesOfAlertN && item.countFaultCodesOfAlertN > 0) {
                        bgColor = "6px solid #e5a846";
                        defaultBgColor = "2px solid #e5a846";
                    } else {
                        bgColor = "6px solid #0061d0";
                        defaultBgColor = "2px solid #0061d0";
                    }

                    if (item.status === 'NORMAL') {
                        componentName += '<span class="instate1">'+t('message.common.text.available')+'</span>';//유효
                        // bgColor = "#5b9bd5";
                    } else if (item.status === 'ALERT') {
                        componentName += '<span class="instate2">'+t('message.common.text.imminent')+'</span>';//임박
                        // bgColor = "#ff0000";
                    } else if (item.status === 'EXPIRED') {
                        componentName += '<span class="instate3">'+t('message.common.text.lapse')+'</span>';//경과
                        // bgColor = "#2c2c2c";
                    }
            
                    const isSelected = componentId === item.id;
                    return (
                        <p className={isSelected ? "statustab2":"statustab3"} key={i} style={{borderBottom:isSelected ? bgColor : defaultBgColor, color:"#fff", fontWeight: isSelected ? 700 : 400}} onClick={()=>{equipmentPartsByComponentId(item.id)}} dangerouslySetInnerHTML={ {__html: componentName} }></p>
                    )
                }) }
            </div>
        </MainCard>
    )
}

export default ComponentStatusDiv;